import apiHelpers from './apiHelpers.js';
import { mapCrudStoreGen } from '@/helpers/utils/storeHelpers.js';

let defaultForm = {
  brandId: '',
  warehouseId: ''
};

let defaultFilters = {
  brandId: '',
  warehouseId: '',
  trackingNumber: '',
  carrier: '',
  processingSystem: '',
  orderId: '',
  isReturnLabel: null,
  isVoided: null,
  shipDateFrom: null,
  shipDateTo: null
};

let defaultPerPageItems = 15;
// if viewport higher then 920px, then 25 items per page
if (window.innerHeight > 920) {
  defaultPerPageItems = 20;
}
let genedStore = mapCrudStoreGen(defaultForm, defaultFilters, apiHelpers);

export default {
  namespaced: true,

  state: () => ({
    ...genedStore.state,
    pagination: {
      page: 1,
      perPage: defaultPerPageItems
    },
  }),

  mutations: {
    ...genedStore.mutations
  },

  getters: {
    ...genedStore.getters
  },

  actions: {
    ...genedStore.actions
  },
};